import { useField } from 'formik';
import { ToggleGroup } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToggleGroupField = ({
  children,
  name,
  ...rootProps
}) => {
  const [field,, helpers] = useField(name);
  return /*#__PURE__*/_jsx(ToggleGroup.Root, {
    ...field,
    onChange: helpers.setValue,
    ...rootProps,
    "data-sentry-element": "unknown",
    "data-sentry-component": "ToggleGroupField",
    "data-sentry-source-file": "ToggleGroupField.tsx",
    children: children
  });
};